<!-- Phone -->
<div *ngIf="formGroup" [formGroup]="formGroup">
    <div class="form-group" [ngClass]="{'has-danger': invalidPhone}">
        <label *ngIf="label" class="font-l1" [ngClass]="isScratch ? 'text-white' : ''">{{label}}</label>
        <div>
            <ngx-intl-tel-input [cssClass]="'form-control'" [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]" [selectedCountryISO]="selectedCountry"
                [maxLength]="phoneLength" [phoneValidation]="true" [searchCountryPlaceholder]="'Código de area'" [separateDialCode]="true" formControlName="phone"
                (countryChange)="onCountryChange($event)" (ngModelChange)="onModelChange($event)" [customPlaceholder]="placeholder">
            </ngx-intl-tel-input>
        </div>
        <div class="form-control-feedback" *ngIf="invalidPhone">
            <small *ngIf="phone.errors?.required" [ngClass]="isScratch ? 'text-white' : ''">
                El teléfono es requerido
            </small>
            <small *ngIf="phone.errors?.validatePhoneNumber" [ngClass]="isScratch ? 'text-white' : ''">
                El formato del teléfono es invalido
            </small>
            <small *ngIf="phone.errors?.minLength" [ngClass]="isScratch ? 'text-white' : ''">
                El teléfono debe tener al menos {{phoneLength}} dígitos
            </small>
        </div>
    </div>
</div>